import { useState } from 'react'
import useSetInterval from '@/hooks/use-interval'
import useTimeout from '@/hooks/use-timeout'
import { Label } from '@/components/text'

const Countdown = ({ text = '', delay, onComplete, ...rest }) => {
  const [count, setCount] = useState(Math.floor(delay / 1000))
  useTimeout(() => {
    onComplete()
  }, delay)
  useSetInterval(() => {
    setCount(current => current - 1)
  }, 1000)
  return (
    <Label fontSize="14px" type="small" {...rest}>
      {text.replace('[current]', count)}
    </Label>
  )
}

export default Countdown
